import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../user/user.service';

@Component({
  selector: 'app-inspection-assignee-filter',
  templateUrl: './inspection-assignee-filter.component.html',
  styleUrls: ['./inspection-assignee-filter.component.scss'],
})
export class InspectionAssigneeFilter implements OnInit {
  assignees = [];
  previousSelectedAssignees: number[] = [];
  @Output() assigneeChange = new EventEmitter<number[]>();
  @Input() filteredAssignees: number[];

  constructor(public userService: UserService) {}
  async ngOnInit() {
    this.assignees = await this.userService.assignees();
    if (this.assignees.length > 0) {
      const currentUser = await this.userService.profile();
      const anyAssignee = { id: -1, name: 'Any Assignee' };
      const unassigned = { id: 0, name: 'Unassigned' };

      this.assignees = this.assignees.filter(a => a.id !== -1 && a.id !== 0);
      const currentUserIndex = this.assignees.findIndex(a => a.id === currentUser.id);
      let signedInUser = null;

      if (currentUserIndex !== -1) {
        signedInUser = this.assignees.splice(currentUserIndex, 1)[0];
      }

      this.assignees = this.assignees.sort((a, b) => a.name.localeCompare(b.name));

      this.assignees = signedInUser
        ? [anyAssignee, unassigned, signedInUser, ...this.assignees]
        : [anyAssignee, unassigned, ...this.assignees];
    }
  }

  getInitials(name: string): string {
    const words = name.trim().split(/\s+/);
    return words.length >= 2 ? words[0][0] + words[1][0] : words[0][0];
  }

  isDefault(id: number): boolean {
    return id === -1 || id === 0;
  }

  onAssigneeChange(assigneeIds: number[]) {
    const hasAnyAssignee = assigneeIds.includes(-1);
    const hasUnassigned = assigneeIds.includes(0);
    const hadAnyAssignee = this.previousSelectedAssignees.includes(-1);

    if (hasAnyAssignee) {
      if (hasUnassigned && !this.previousSelectedAssignees.includes(0)) {
        this.filteredAssignees = [0];
      } else {
        this.filteredAssignees = hadAnyAssignee
          ? assigneeIds.filter(i => i !== -1)
          : this.assignees.filter(a => a.id !== 0).map(a => a.id);
      }
    } else {
      if (hadAnyAssignee) {
        this.filteredAssignees = [];
      }
    }

    this.previousSelectedAssignees = [...this.filteredAssignees];
    this.assigneeChange.emit(this.filteredAssignees);
  }

  get filteredAssigneesCount(): number {
    return this.filteredAssignees.filter(id => id !== -1).length;
  }

  scrollDropdownToTop() {
    setTimeout(() => {
      const dropdownPanel = document.querySelector('.ng-dropdown-panel .ng-dropdown-panel-items');
      if (dropdownPanel) {
        dropdownPanel.scrollTop = 0;
      }
    }, 0);
  }
  reset() {
    this.filteredAssignees = [];
  }
}
